export enum StandardSequenceStep {
  OPENING = "OPENING",
  FOLLOW_UP_1 = "FOLLOW_UP_1",
  FOLLOW_UP_2 = "FOLLOW_UP_2",
  FOLLOW_UP_3 = "FOLLOW_UP_3",
  BREAK_UP = "BREAK_UP",
}
